// Design: stock at most 2.
export const LOW_STOCK_LIMIT = 2;
